import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../api/apihandler';
import { AD_LIST, AD_VIEW, AD_CLICK } from '../../api/constants';

const RailAdItem = ({ ad }) => {
  const image = ad?.user_post_images?.[0]?.image_path;

  useEffect(() => {
    apiHandler(AD_VIEW, 'POST', { ad_id: ad.id, device_type: 0 }).catch(() => {});
  }, [ad.id]);

  const trackClick = () => {
    apiHandler(AD_CLICK, 'POST', { ad_id: ad.id, device_type: 0 }).catch(() => {});
  };

  return (
    <a
      href={ad?.user_post_ad?.ad_link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackClick}
      className="nmha-rail-ad-card"
    >
      {image && (
        <div className="nmha-rail-ad-media">
          <img src={image} alt="" className="nmha-rail-ad-img" />
          <span className="nmha-rail-ad-tag">Ad</span>
        </div>
      )}
      <div className="nmha-rail-ad-body">
        <p className="nmha-rail-ad-title">{ad?.user_post_ad?.title}</p>
        <p className="nmha-rail-ad-cta">{ad?.user_post_ad?.button_text || 'Learn more'}</p>
      </div>
    </a>
  );
};

// Right-rail "Sponsored" block on the home feed. Shows up to two ads from
// the "Right" ad position (position=1 in the ad-creation flow).
const AdRailWidget = () => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiHandler(AD_LIST, 'POST', { page: 1, limit: 2, position: '1' });
        if (cancelled) return;
        const listData = res?.data?.data?.userPosts;
        if (listData?.meta?.total > 0) setAds(listData?.data || []);
      } catch (e) { console.error(e); }
    })();
    return () => { cancelled = true; };
  }, []);

  if (ads.length === 0) return null;

  return (
    <div className="nmha-rail-block">
      <div className="nmha-rail-head"><h3>Sponsored</h3></div>
      {ads.map((ad) => <RailAdItem ad={ad} key={ad.id} />)}
    </div>
  );
};

export default AdRailWidget;
